import React from 'react'

import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
import { Controller, FormProvider, useForm } from 'react-hook-form'
import { Spacer } from 'src/components/__legacy__/spacer/spacer'

import { ModalCancelButton } from '../../../../../../../../lib/chakra-theme/components'

type Props = {
  title: string
  isOpen: boolean
  onClose: () => void
  onSubmit: (comment: string) => void
  required: boolean
  submitText: string
  buttonColorScheme?: 'blue' | 'red'
  descriptionComponent: React.ReactNode
}

type FormValue = {
  comment: string
}

const MAX_COMMENT_LENGTH = 255

export const WithCommentModalRenewal: React.FC<Props> = ({
  title,
  isOpen,
  onClose,
  onSubmit: _onSubmit,
  required,
  descriptionComponent,
  submitText,
  buttonColorScheme,
}) => {
  const methods = useForm<FormValue>()

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = methods

  const onSubmit = (data: FormValue) => {
    _onSubmit(data.comment)
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalContent>
            <ModalCloseButton />
            <ModalHeader>{title}</ModalHeader>
            <ModalBody>
              {descriptionComponent}
              {descriptionComponent !== null && <Spacer size={16} />}
              <FormControl isInvalid={!!errors.comment}>
                <FormLabel>コメント{!required && <>(任意)</>}</FormLabel>
                <Controller
                  name="comment"
                  control={control}
                  rules={{
                    required: {
                      value: required,
                      message: 'コメントは必須です。',
                    },
                    maxLength: {
                      value: MAX_COMMENT_LENGTH,
                      message: `${MAX_COMMENT_LENGTH}文字以内で入力してください。`,
                    },
                  }}
                  render={({ field }) => <Input {...field} />}
                />
                <FormErrorMessage>{errors.comment?.message}</FormErrorMessage>
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <ModalCancelButton />
              <Button
                type="submit"
                isDisabled={!!errors.comment}
                colorScheme={buttonColorScheme}
              >
                {submitText}
              </Button>
            </ModalFooter>
          </ModalContent>
        </form>
      </FormProvider>
    </Modal>
  )
}
